import React, { useState } from 'react';
import Modal from './Modal'; // Asumimos que tienes un componente base de Modal

const CreateTaskModal = ({ isOpen, onClose, modalData }) => {
  const [description, setDescription] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { onTaskAdded } = modalData || {};

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!description.trim()) {
      // Puedes mostrar un mensaje de error al usuario aquí
      return;
    }
    setIsSubmitting(true);
    try {
      if (typeof onTaskAdded !== 'function') {
        console.error("onTaskAdded no es una función");
        return;
      }
      await onTaskAdded(description);
      setDescription('');
      onClose();
    } catch (error) {
      // El error ya es manejado por el todoStore, solo logueamos si es necesario
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Añadir Nueva Tarea">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="taskDescription" className="block text-sm font-medium text-gray-700">
            Descripción de la Tarea
          </label>
          <textarea
            id="taskDescription"
            rows="4"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
            placeholder="Describe la tarea a realizar..."
            required
          ></textarea>
        </div>
        <div className="flex justify-end space-x-3">
          <button type="button" onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300" disabled={isSubmitting}>Cancelar</button>
          <button type="submit" className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:bg-blue-400" disabled={isSubmitting}>
            {isSubmitting ? 'Añadiendo...' : 'Añadir Tarea'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default CreateTaskModal;